/**
 * Wraps window.fetch function so we use the raw window fetch
 * on client over what NextJS implements when it bundles the JS
 * @param input path to resource to fetch
 * @param init request options
 * @returns window fetch function if on client, else NextJS fetch function
 */
export default function updaterFetch(
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> {
  if (typeof window !== 'undefined') {
    return window.fetch(input, init);
  }
  return fetch(input, init);
}
